export default ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
    return {
        searchPolicies: (policySearchCriteria) => {
            return JsonRPCService.send('cc', 'gatewayfnol/policy', 'searchPolicies', [policySearchCriteria]);
        },
        getPolicySummaryRiskUnits: (policyNumber, lossDate) => {
            return JsonRPCService.send('cc', 'gatewayfnol/policy', 'getPolicySummaryRiskUnits', [policyNumber, lossDate]);
        }
    };
}];
